import styled from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";
import {VouchersGamesListTitleDefaultBox} from "./voucher-games-list-title.default.box";

export const VouchersGamesListTitleMrGreenBox = styled(VouchersGamesListTitleDefaultBox)`
    border-bottom: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
`;
